import ExternalLink from '../../ExternalLink';

import './GenericBanner.scss';

const GenericBanner = ({
  content,
}) => {
  const {
    title,
    description,
    ctaLabel,
    ctaURL,
    srcImage,
    nameId,
    backgroundImg,
    trackerProps = {},
  } = content;
  return (
    <div id={nameId} className="GenericBanner">
      <div className="GenericBanner__container">
        <div className="GenericBanner__title">
          {title}
        </div>
        <div className="GenericBanner__description">
          {description}
        </div>
        {ctaLabel && (
          <ExternalLink
            className="GenericBanner__cta"
            href={ctaURL ?? '#'}
            {...trackerProps}
          >
            {ctaLabel}
          </ExternalLink>
        )}
      </div>
      {srcImage && (
        <div className="GenericBanner__img">
          <img className="GenericBanner__icon" src={srcImage} alt="generic banner" />
          {backgroundImg && <img className="GenericBanner__star" src={backgroundImg} alt="star" />}
        </div>
      )}
    </div>
  );
};

export default GenericBanner;
